'use client';

import { c as _c } from "react/compiler-runtime";
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/16/solid';
import { useEffect, useState } from 'react';
import { Button } from '@/frontend/design-system/actions/Button';
import { H2 } from '@/frontend/design-system/typography/Heading';
import { PaginationDots } from './PaginationDots';
import { type Review, ReviewCard } from './ReviewCard';
type ReviewsProps = {
  reviews: Review[];
};
export function Reviews(t0) {
  const $ = _c(46);
  const {
    reviews
  } = t0;
  const [page, setPage] = useState(0);
  const [visibleCount, setVisibleCount] = useState(3);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const handleResize = function handleResize() {
        if (window.innerWidth >= 1280) {
          setVisibleCount(3);
        } else {
          if (window.innerWidth >= 768) {
            setVisibleCount(2);
          } else {
            setVisibleCount(1);
          }
        }
      };
      handleResize();
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  if (!reviews || reviews.length === 0) {
    return null;
  }
  const totalPages = Math.ceil(reviews.length / visibleCount);
  const startIndex = page * visibleCount;
  const endIndex = startIndex + visibleCount;
  let canGoRight;
  let handleNext;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[2] !== endIndex || $[3] !== page || $[4] !== reviews || $[5] !== startIndex || $[6] !== totalPages) {
    const visibleReviews = reviews.slice(startIndex, endIndex);
    const canGoLeft = page > 0;
    canGoRight = page < totalPages - 1;
    let t9;
    if ($[15] !== canGoLeft || $[16] !== page) {
      t9 = () => {
        if (canGoLeft) {
          setPage(page - 1);
        }
      };
      $[15] = canGoLeft;
      $[16] = page;
      $[17] = t9;
    } else {
      t9 = $[17];
    }
    const handlePrev = t9;
    let t10;
    if ($[18] !== canGoRight || $[19] !== page) {
      t10 = () => {
        if (canGoRight) {
          setPage(page + 1);
        }
      };
      $[18] = canGoRight;
      $[19] = page;
      $[20] = t10;
    } else {
      t10 = $[20];
    }
    handleNext = t10;
    t7 = "flex w-full flex-col items-center space-y-6";
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <H2>Opinie</H2>;
      $[21] = t8;
    } else {
      t8 = $[21];
    }
    t5 = "flex items-center justify-between gap-2 lg:gap-4";
    if ($[22] !== canGoLeft || $[23] !== handlePrev || $[24] !== totalPages) {
      t6 = totalPages > 1 && <Button outline={true} onClick={handlePrev} disabled={!canGoLeft} className="px-2 py-1"><ChevronLeftIcon /></Button>;
      $[22] = canGoLeft;
      $[23] = handlePrev;
      $[24] = totalPages;
      $[25] = t6;
    } else {
      t6 = $[25];
    }
    t3 = "flex items-stretch justify-between gap-4";
    t4 = visibleReviews.map(_temp);
    $[2] = endIndex;
    $[3] = page;
    $[4] = reviews;
    $[5] = startIndex;
    $[6] = totalPages;
    $[7] = canGoRight;
    $[8] = handleNext;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    canGoRight = $[7];
    handleNext = $[8];
    t3 = $[9];
    t4 = $[10];
    t5 = $[11];
    t6 = $[12];
    t7 = $[13];
    t8 = $[14];
  }
  let t9;
  if ($[26] !== t3 || $[27] !== t4) {
    t9 = <div className={t3}>{t4}</div>;
    $[26] = t3;
    $[27] = t4;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] !== canGoRight || $[30] !== handleNext || $[31] !== totalPages) {
    t10 = totalPages > 1 && <Button outline={true} onClick={handleNext} disabled={!canGoRight} className="px-2 py-1"><ChevronRightIcon className="h-4 w-4" /></Button>;
    $[29] = canGoRight;
    $[30] = handleNext;
    $[31] = totalPages;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  let t11;
  if ($[33] !== t10 || $[34] !== t5 || $[35] !== t6 || $[36] !== t9) {
    t11 = <div className={t5}>{t6}{t9}{t10}</div>;
    $[33] = t10;
    $[34] = t5;
    $[35] = t6;
    $[36] = t9;
    $[37] = t11;
  } else {
    t11 = $[37];
  }
  let t12;
  if ($[38] !== page || $[39] !== totalPages) {
    t12 = totalPages > 1 && <PaginationDots total={totalPages} current={page} onChange={idx => setPage(idx)} />;
    $[38] = page;
    $[39] = totalPages;
    $[40] = t12;
  } else {
    t12 = $[40];
  }
  let t13;
  if ($[41] !== t11 || $[42] !== t12 || $[43] !== t7 || $[44] !== t8) {
    t13 = <div className={t7}>{t8}{t11}{t12}</div>;
    $[41] = t11;
    $[42] = t12;
    $[43] = t7;
    $[44] = t8;
    $[45] = t13;
  } else {
    t13 = $[45];
  }
  return t13;
}
function _temp(review) {
  return <div key={review.id} className="max-w-90 flex-1"><ReviewCard review={review} /></div>;
}